var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.6111C9.27222 13.6111 8.06667 12.8222 7.46667 11.6667H10.6667V10.5556H7.1C7.07222 10.3722 7.05556 10.1889 7.05556 10C7.05556 9.81111 7.07222 9.62778 7.1 9.44444H10.6667V8.33333H7.46667C8.06667 7.17778 9.27778 6.38889 10.6667 6.38889C11.5611 6.38889 12.3833 6.71667 13.0167 7.26111L14 6.27778C13.1167 5.48333 11.9444 5 10.6667 5C8.48889 5 6.64444 6.39444 5.95556 8.33333H4V9.44444H5.7C5.67778 9.62778 5.66667 9.81111 5.66667 10C5.66667 10.1889 5.67778 10.3722 5.7 10.5556H4V11.6667H5.95556C6.64444 13.6056 8.48889 15 10.6667 15C11.95 15 13.1167 14.5167 14 13.7222L13.0111 12.7389C12.3833 13.2833 11.5667 13.6111 10.6667 13.6111Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.63a63a26491c6b72239f3bde78a523ae.svg";
export { ForwardRef as ReactComponent };